import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { QuestionsAndAnswerModel } from '@app/_models/faq/questionsAndAnswers.model';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FaqQuestionsAndAnswersService {

  constructor(private http: HttpClient) { }

  getAllQuestionsAndAnswersForModule(id: string) {
    return this.http.get<QuestionsAndAnswerModel[]>(`${environment.apiUrl}/api/faq/questions/${id}`);
  }
}
